export const weidu = [
    { name: "自我提升", group: "个性特征", value: 4 },
    { name: "业务敏锐", group: "业务/管理", value: 1 },
    { name: "制定\n战略方向", group: "业务/管理", value: 2 },
    { name: "制定\n运营角色", group: "业务/管理", value: 3 },
    { name: "推动执行", group: "业务/管理", value: 2.2 },
    { name: "团队领导", group: "领导力", value: 1 },
    { name: "引领变革", group: "领导力", value: 3 },
    { name: "营造良好\n工作关系", group: "人际交往", value: 2 },
    { name: "情商", group: "人际交往", value: 4 },
  ]

export const groups = [
  {
    name:'业务/管理',ranking:4,list:
    [
      {name:'业务敏锐',title:'利用个人对关键业务驱动力的理解，发现、创造和把握机会；拓展新的业务，并推出创新产品和服务。',items:[{name:'上级',num:2,value:1.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
      {name:'制定战略方向',title:'根据对信息系统的分析，以及对资源、业务驱动力及组织价值观的考虑，制定长期业务方向。',items:[{name:'上级',num:2,value:4.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
      {name:'制定运营决策',title:'获取并比较不同来源的信息以识别业务问题；以关键决策标准来衡量各种备选方案，选择最佳行动方案并全力以赴。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
      {name:'推动执行',title:'将战略重点转化为实际成果；协调沟通、责任、资源、内部流程和长期评估体系以确保战略重点产生可衡量的长期成果。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
    ]
  },
  {
    name:'领导力',ranking:4,list:
    [
      {name:'引领变革',title:'确定并推动必要的组织变革，从策略上适应不断变化的市场环境、技术和内部举措；通过转变流程、系统、产品/服务或做事风格，来催生新方法，提高成果。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
      {name:'制定战略方向',title:'根据对信息系统的分析，以及对资源、业务驱动力及组织价值观的考虑，制定长期业务方向。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
    ]
  },
  {
    name:'人际交往',ranking:4,list:
    [
      {name:'情商',title:'通过准确察觉和解读自身及他人在组织环境中的情绪与行为，建立并维系信任关系；利用自己的洞察有效管理自身的反应。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
      {name:'营造良好工作',title:'关系与组织内、外部的利益相关者（如客户、同事、跨职能伙伴、外部供应商及联盟伙伴）建立并保持战略关系，以实现业务目标。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]}
    ]
  },
  {
    name:'个性特征',ranking:4,list:
    [
      {name:'自我提升',title:'积极寻求发展体验，提高人际影响力和业务影响力。',items:[{name:'上级',num:2,value:3.7},{name:'平级',num:6,value:3.2},{name:'下级',num:4,value:2.8}]},
    ]
  },
]

export const groupsConfig = [
  { min:0,max:2,name:'不足' },
  { min:2,max:3,name:'有限' },
  { min:3,max:3.5,name:'一般' },
  { min:3.5,max:4,name:'熟练' },
  { min:4,max:5,name:'精通' },
]



// WEBPACK FOOTER //
// ./src/components/dataView/table/config.js